module.exports = __webpack_public_path__ + "static/media/KMH_5169.76526f04.jpg";